import { action } from 'mobx';
import { ProductService, HistoryLogService } from 'common/data';
import _ from 'lodash';
import { BaseStore } from 'core/stores';

class ProductStore extends BaseStore {
	constructor(rootStore) {
		super(new ProductService(rootStore.app.baasic.apiClient));
		this.historyLogService = new HistoryLogService(rootStore.app.baasic.apiClient);
	}

	@action
	findProduct = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	findProductHistoryLog = async filter => {
		const response = await this.historyLogService.find(filter);
		_.each(response.data.item, responseItem => {
			responseItem.changed = JSON.parse(responseItem.changed);
		});
		this.response = response.data;
	};

	@action
	linkProduct = async (product, sourceOfChange) => {
		const response = await this.service.linkProduct(product, sourceOfChange);
		return response;
	};

	@action
	getProduct = async (id, options) => {
		let product = await this.service.get(id, options);
		this.item = product.data;
		return product.data;
	};

	@action
	updateProduct = async (product, sourceOfChange) => {
		await this.service.update(product, sourceOfChange);
	};

	@action
	updateProducts = async (products, sourceOfChange) => {
		await this.service.updateProducts(products, sourceOfChange);
	};

	@action
	setProductActivity = async (product, sourceOfChange) => {
		const response = await this.service.setProductActivity(product, sourceOfChange);
		return response;
	};

	@action
	createProduct = async (product, sourceOfChange) => {
		const response = await this.service.create(product, sourceOfChange);
		this.item = response;
		return this.item.data;
	};

	@action
	createProducts = async (products, sourceOfChange) => {
		const response = await this.service.createBatch(products, sourceOfChange);
		this.item = response;
		return this.item.data;
	};

	@action
	deleteProduct = async product => {
		product = { id: product.id };
		await this.service.delete(product);
	};
}

export default ProductStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/ProductStore.js